module.exports = __webpack_public_path__ + "static/media/flu-gray.11dbc076.svg";